import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpModule } from '@angular/http';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { BrowserModule } from '@angular/platform-browser';
import { SearchInputComponent } from './search-input/search-input.component';
import { PaginationComponent } from './pagination/pagination.component';
import { PaginationDropdownComponent } from './pagination-dropdown/pagination-dropdown.component';
import { LocationFilterInputComponent } from './location-filter-input/location-filter-input.component';
import { AdminComponent } from './admin/admin.component';
import { customHttpProvider } from './services/chttp.service';
import { SortableComponent } from './sortable/sortable.component';
import { LoaderComponent } from './loader/loader.component';
import { RouteHelperService } from './services/route-helper.service';
import { DialogComponent } from './dialog/dialog.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { LiveSearchComponent } from './live-search/live-search.component';
import { DaterangepickerComponent } from './daterangepicker/daterangepicker.component';
import { Daterangepicker } from 'ng2-daterangepicker';
import { CheckboxGroupComponent } from './checkbox-group/checkbox-group.component';
import { DatetimePickerComponent } from './datetime-picker/datetime-picker.component';
// import { A2Edatetimepicker } from 'ng2-eonasdan-datetimepicker';
import { DatetimePickerDirective } from './datetime-picker/datetime-picker.directive';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { DatepickerDirective } from './datepicker/datepicker.directive';
import { DateFormatPipe } from './pipes/date-format.pipe';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { WysiwygComponent } from './wysiwyg/wysiwyg.component';
import { WysiwygDirective } from './wysiwyg/wysiwyg.directive';
import { ImageUploadComponent } from './image-upload/image-upload.component';
import { ResourceService } from './services/resource.service';
import { ImageViewComponent } from './image-view/image-view.component';
import { MassActionsModalDialogComponent } from './modal-dialog/modal-dialog.component';
import { MemberPreviewModalDialogComponent } from './member-preview-modal-dialog/member-preview-modal-dialog.component';
import { MemberInvalidPlanModalDialogComponent } from './member-invalid-plan-modal-dialog/member-invalid-plan-modal-dialog.component';
import { OfferExportModalDialogComponent } from './offer-export-modal-dialog/offer-export-modal-dialog.component';
import { AddSubscriptionModalDialogComponent } from './add-subscription-modal-dialog/add-subscription-modal-dialog.component';
import { SelectPickerComponent } from './widgets/select-picker/select-picker.component';
import { ImageViewerModule } from '@hallysonh/ngx-imageviewer';
import 'hammerjs';
import { FileViewerComponent } from './file-viewer/file-viewer.component';
import { LoadingButtonComponent } from './loading-button/loading-button.component';
import { NavigationService } from './services/navigation.service';
import { PageParamStorageService } from './services/page-param-storage.service';
import { MemberExportModalEmailDialogComponent } from './member-export-modal-email-dialog/member-export-modal-email-dialog.component';
import { AddSubscriptionQuarterliesModalDialogComponent } from './add-subscription-quarterlies-modal-dialog/add-subscription-quarterlies-modal-dialog.component';
import { OfferPreviewModalDialogComponent } from './offer-preview-modal-dialog/offer-preview-modal-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule,
    HttpModule,
    FormsModule,
    Daterangepicker,
    ImageViewerModule,
    // A2Edatetimepicker
  ],
  exports: [
    HeaderComponent,
    SidebarComponent,
    SearchInputComponent,
    PaginationComponent,
    PaginationDropdownComponent,
    SortableComponent,
    DialogComponent,
    LiveSearchComponent,
    DaterangepickerComponent,
    CheckboxGroupComponent,
    DatetimePickerComponent,
    DatepickerComponent,
    BreadcrumbComponent,
    LoaderComponent,
    WysiwygComponent,
    ImageUploadComponent,
    ImageViewComponent,
    MassActionsModalDialogComponent,
    MemberPreviewModalDialogComponent,
    MemberInvalidPlanModalDialogComponent,
    OfferPreviewModalDialogComponent,
    OfferExportModalDialogComponent,
    AddSubscriptionModalDialogComponent,
    SelectPickerComponent,
    LoadingButtonComponent,
    DateFormatPipe,
    MemberExportModalEmailDialogComponent,
    AddSubscriptionQuarterliesModalDialogComponent,
  ],
  providers: [customHttpProvider, RouteHelperService, ResourceService, NavigationService, PageParamStorageService],
  declarations: [
    HeaderComponent,
    SidebarComponent,
    SearchInputComponent,
    PaginationComponent,
    PaginationDropdownComponent,
    LocationFilterInputComponent,
    AdminComponent,
    SortableComponent,
    LoaderComponent,
    DialogComponent,
    NotFoundComponent,
    LiveSearchComponent,
    DaterangepickerComponent,
    CheckboxGroupComponent,
    DatetimePickerComponent,
    DatetimePickerDirective,
    DatepickerComponent,
    DatepickerDirective,
    DateFormatPipe,
    BreadcrumbComponent,
    WysiwygComponent,
    WysiwygDirective,
    ImageUploadComponent,
    ImageViewComponent,
    MassActionsModalDialogComponent,
    MemberPreviewModalDialogComponent,
    MemberInvalidPlanModalDialogComponent,
    OfferPreviewModalDialogComponent,
    OfferExportModalDialogComponent,
    AddSubscriptionModalDialogComponent,
    SelectPickerComponent,
    FileViewerComponent,
    LoadingButtonComponent,
    MemberExportModalEmailDialogComponent,
    AddSubscriptionQuarterliesModalDialogComponent,
  ],
})
export class CoreModule { }



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/core.module.ts